<template>
  <div id="app" class="application-root">   
    <navbar v-if="this.$route.name != 'dashboard'"></navbar>
    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>
 
  
<script>
//<navigation v-if="['login', 'register'].includes($route.name)"></navigation>
import navbar from "@/components/navbar"
export default {
    name: 'App',
    components:{
      navbar
    },
      
    data (){
      return {
        isLoading: true,
        app: 1,
        element: 'appRoot',
        data: []
      }
    },

    created(){
      var vm = this;
    }
}
</script>




<style lang="scss">
/*
$baseColor: #222;
#app {  
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: $baseColor;
  }


:root{
  font-size: .14px;		
  font-size: .8rem !important;		
  font-size: 12px !important;	
}

html{
  font-size: .14px;  
  font-size: .8rem !important;	
  font-size: 62.5% !important;	
}
*/
.navbar-item img {
    max-height: unset !important;
}


/* html {font-size: .81rem;}

html {
  font-size: 12px;
  @include tablet {
    font-size: 16px;
  }
  @include desktop {
    font-size: 20px;
  }
}

*/
/*#app > .container {font-size: 1.05rem !important;}

#app ::-webkit-scrollbar-thumb, #tabulator ::-webkit-scrollbar-thumb, .tabulator-tableHolder ::-webkit-scrollbar-thumb{
  cursor: pointer;
  border-radius: 5px;
  background: rgba(0,0,0,.25);
  -webkit-transition: color .2s ease;
  transition: color .2s ease;
}

.navbar a{text-shadow: 0px 1px 1px rgba(59,58,76,0.0);
font-weight: 400;

}
#nav {
  padding: 30px;
  a {
    font-weight: 300;
    text-shadow: 1px 2px 2px rgba(59,58,76,0.41);
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

*/


.fade-enter { opacity: 100;}
.fade-enter-active { transition: opacity 0.1s ease;}
.fade-leave {opacity: 0;}
.fade-leave-active {
  transition: opacity 0.1s ease;
  opacity: 0;
}
</style>
